import {
  createPersistedConfigContext,
  type PersistedConfigContextValue,
} from '../../config/persistedConfig';
import { type JamCamStageConfig, stageConfigStore } from './stageConfig';

const stageContext = createPersistedConfigContext(stageConfigStore);

export const JamCamStageConfigProvider = stageContext.Provider;

export function useJamCamStageConfig(): PersistedConfigContextValue<JamCamStageConfig> {
  return stageContext.useConfig();
}
